import React from 'react'
// import {useTranslation} from 'react-i18next'
import OrderDetailsContainer from '../@c_containers/order_details/order_details.container'

const HomePage = function () {
  // const {t} = useTranslation()
  return (
    <>
      {/* <h2>{t('homePageTitle')}</h2> */}
      <OrderDetailsContainer />
    </>
  )
}

export default HomePage
